"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const proxy_watcher_1 = require("proxy-watcher");
/* UTILS */
const Utils = {
    isEqual: (x, y) => {
        if (x.length !== y.length)
            return false;
        for (let i = 0, l = x.length; i < l; i++) {
            if (x[i] !== y[i])
                return false;
        }
        return true;
    },
    isStores: (value) => {
        return Array.isArray(value) && !proxy_watcher_1.isProxy(value);
    },
    uniq: (arr) => {
        if (arr.length < 2)
            return arr;
        return Array.from(new Set(arr).values());
    },
    paths: {
        rootify: (paths) => {
            return paths.map(path => {
                const dotIndex = path.indexOf('.');
                if (dotIndex < 0)
                    return path;
                return path.slice(0, dotIndex);
            });
        }
    },
    log: {
        group: (title, collapsed = true, fn) => {
            collapsed ? console.groupCollapsed(title) : console.group(title);
            fn();
            console.groupEnd();
        }
    }
};
/* EXPORT */
exports.default = Utils;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUNBLFlBQVk7O0FBRVosaURBQXNDO0FBR3RDLFdBQVc7QUFFWCxNQUFNLEtBQUssR0FBRztJQUVaLE9BQU8sRUFBRSxDQUFFLENBQVEsRUFBRSxDQUFRLEVBQVksRUFBRTtRQUV6QyxJQUFLLENBQUMsQ0FBQyxNQUFNLEtBQUssQ0FBQyxDQUFDLE1BQU07WUFBRyxPQUFPLEtBQUssQ0FBQztRQUUxQyxLQUFNLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsQ0FBQyxDQUFDLE1BQU0sRUFBRSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsRUFBRSxFQUFHO1lBRTFDLElBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUM7Z0JBQUcsT0FBTyxLQUFLLENBQUM7U0FFbkM7UUFFRCxPQUFPLElBQUksQ0FBQztJQUVkLENBQUM7SUFFRCxRQUFRLEVBQUUsQ0FBRSxLQUFVLEVBQXFCLEVBQUU7UUFFM0MsT0FBTyxLQUFLLENBQUMsT0FBTyxDQUFHLEtBQUssQ0FBRSxJQUFJLENBQUMsdUJBQU8sQ0FBRyxLQUFLLENBQUUsQ0FBQztJQUV2RCxDQUFDO0lBRUQsSUFBSSxFQUFFLENBQU0sR0FBUSxFQUFRLEVBQUU7UUFFNUIsSUFBSyxHQUFHLENBQUMsTUFBTSxHQUFHLENBQUM7WUFBRyxPQUFPLEdBQUcsQ0FBQztRQUVqQyxPQUFPLEtBQUssQ0FBQyxJQUFJLENBQUcsSUFBSSxHQUFHLENBQUcsR0FBRyxDQUFFLENBQUMsTUFBTSxFQUFHLENBQUUsQ0FBQztJQUVsRCxDQUFDO0lBRUQsS0FBSyxFQUFFO1FBRUwsT0FBTyxFQUFFLENBQUUsS0FBZSxFQUFhLEVBQUU7WUFFdkMsT0FBTyxLQUFLLENBQUMsR0FBRyxDQUFHLElBQUksQ0FBQyxFQUFFO2dCQUV4QixNQUFNLFFBQVEsR0FBRyxJQUFJLENBQUMsT0FBTyxDQUFHLEdBQUcsQ0FBRSxDQUFDO2dCQUV0QyxJQUFLLFFBQVEsR0FBRyxDQUFDO29CQUFHLE9BQU8sSUFBSSxDQUFDO2dCQUVoQyxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUcsQ0FBQyxFQUFFLFFBQVEsQ0FBRSxDQUFDO1lBRXBDLENBQUMsQ0FBQyxDQUFDO1FBRUwsQ0FBQztLQUVGO0lBRUQsR0FBRyxFQUFFO1FBRUgsS0FBSyxFQUFFLENBQUUsS0FBYSxFQUFFLFlBQXFCLElBQUksRUFBRSxFQUFZLEVBQVMsRUFBRTtZQUV4RSxTQUFTLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxjQUFjLENBQUcsS0FBSyxDQUFFLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUcsS0FBSyxDQUFFLENBQUM7WUFFdkUsRUFBRSxFQUFHLENBQUM7WUFFTixPQUFPLENBQUMsUUFBUSxFQUFHLENBQUM7UUFFdEIsQ0FBQztLQUVGO0NBRUYsQ0FBQztBQUVGLFlBQVk7QUFFWixrQkFBZSxLQUFLLENBQUMifQ==